exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pg-sales-tax-table tbody tr td[data-v-b8d620c8] {\n  font-size: 13px;\n  font-weight: normal;\n}\n.icon-inner-input[data-v-b8d620c8] {\n  position: relative;\n}\n.icon-inner-input .fa-spin[data-v-b8d620c8] {\n  position: absolute;\n  padding: 10px;\n  pointer-events: none;\n}\n.right-side-icon .fa-spin[data-v-b8d620c8] {\n  right: 0px;\n}\n.right-side-icon input[data-v-b8d620c8] {\n  padding-right: 30px;\n}\n", ""]);

// exports
